export default class DateFormat {

	static keys = ['yyyy', 'mm', 'dd', 'hh', 'ii', 'ss'];

	/**
	 * @param {int} number
	 *
	 * @return {string}
	 */
	static pad(number) {
		return number < 10 ? '0' + number : number;
	}

	/**
	 * @param {Date} date
	 *
	 * @return {string}
	 */
	static dd(date) {
		return DateFormat.pad(date.getDate());
	}

	/**
	 * @param {Date} date
	 *
	 * @return {string}
	 */
	static mm(date) {
		return DateFormat.pad(date.getMonth() + 1);
	}

	/**
	 * @param {Date} date
	 *
	 * @return {string}
	 */
	static yyyy(date) {
		return '' + date.getFullYear();
	}

	/**
	 * @param {Date} date
	 *
	 * @return {string}
	 */
	static hh(date) {
		return DateFormat.pad(date.getHours());
	}

	/**
	 * @param {Date} date
	 *
	 * @return {string}
	 */
	static ii(date) {
		return DateFormat.pad(date.getMinutes());
	}

	/**
	 * @param {Date} date
	 *
	 * @return {string}
	 */
	static ss(date) {
		return DateFormat.pad(date.getSeconds());
	}

	/**
	 * Replaces pre-defined keys with values, ie: yyyy with 2018
	 *
	 * @param {Date} date
	 * @param {string} format
	 *
	 * @return {string}
	 */
	static format(date, format) {
		const length = format.length;
		DateFormat.keys.forEach((key) => {
			const index = format.indexOf(key);
			if (index > -1) {
				const value = DateFormat[key](date);
				format = format.substring(0, index) + value + format.substring(index + key.length, length);
			}
		});

		return format;
	}
}


// WEBPACK FOOTER //
// ./services/DateFormat.js